// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'jquery'
import './assets/css/global.css'
import {
  showWindowHref
} from './plugin/g_methods'
import './plugin/nativeCall'
import './plugin/ajax'
import './plugin/buryingPointWeb'
import './plugin/preventReClick.js'
import './assets/js/element-ui'
import './assets/js/vant'
import dayjs from 'dayjs'
import VConsole from 'vconsole';
import BigNumber from "bignumber.js";
Vue.config.devtools = true;

import * as filters from './plugin/filters.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
if (process.env.NODE_ENV == 'test') {
  Vue.config.productionTip = false
  //手机调试插件
  Vue.prototype.$vconsole = new VConsole();
}

Vue.prototype.showWindowHref = showWindowHref;
Vue.prototype.$dayjs = dayjs;
Vue.prototype.H5_IMG_HOST = 'https://eventimg.oss-cn-shenzhen.aliyuncs.com/micro_station/tlcj-app-h5';

BigNumber.config({
  EXPONENTIAL_AT: [-10, 40]
})
Vue.use(BigNumber)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  mounted() {
    let special_page = ["gyro_answer", "estate_blockchain_detail"];
    let wait = 1000;
    if (special_page.indexOf(this.$route.name) == -1 && window.location.host.indexOf("localhost") < 0) {
      try {
        isIosorAndroid({
          type: 15,
          url: "",
          title: "",
          description: "",
          imgUrl: "",
          id: "",
          name: "",
        });
      } catch (error) {

      }
      // setTimeout(() => {
      //   Vue.prototype.$maidian("10000000", this.$route.meta.title);
      // }, wait)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js